import {Dispatch, SetStateAction} from 'react';
import {ImageType} from 'react-images-uploading';
import {Store} from '../../../../auth/common/Types';
import {BusinessHour, Day} from '../../../../../common/types/BusinessTimes';
import {Gender} from '../../../../../common/types/Gender';

export const GenreBeauty = 'BEAUTY';

export interface Genre {
	key: string;
	value: string;
}

export interface Service {
	key: string;
	value: string;
}

export interface GenreList {
	category: Genre[];
}

export type GenreMap = Record<string, Genre>;

export enum SocialPostTypes {
	igPost = 'INSTAGRAM_POST',
	igStory = 'INSTAGRAM_STORY',
	tiktok = 'TIKTOK',
}

export type SocialPostType = SocialPostTypes.igPost | SocialPostTypes.igStory | SocialPostTypes.tiktok;

export enum Platforms {
	ig = 'instagram',
	tiktok = 'tiktok',
}

export type Platform = Platforms.ig | Platforms.tiktok;

export type FollowerCount = Record<Platform, number | undefined>;

export interface CampaignCreateData {
	genre?: Genre;
	setGenre: (genre: Genre) => void;
	service?: Service;
	setService: (service: Service) => void;
	socialPostTypes: SocialPostType[];
	setSocialPostTypes: Dispatch<SetStateAction<SocialPostType[]>>;
	store?: Store;
	setStore: (store: Store) => void;
	title?: string;
	setTitle: (title: string) => void;
	thumb?: ImageType;
	setThumb: (thumb: ImageType) => void;
	thumbUrl?: string;
	setThumbUrl?: (thumbUrl: string) => void;
	images: ImageType[];
	setImages: (images: ImageType[]) => void;
	summary?: string;
	setSummary: (summary: string) => void;
	charge?: number;
	setCharge: (charge: number) => void;
	hours?: BusinessHour;
	setHours: (hours: BusinessHour) => void;
	holidays: Day[];
	setHolidays: Dispatch<SetStateAction<Day[]>>;
	treatmentTime?: number;
	setTreatmentTime: (slots: number) => void;
	slots?: number;
	setSlots: (slots: number) => void;
	genders: Gender[];
	setGenders: Dispatch<SetStateAction<Gender[]>>;
	followers?: FollowerCount;
	updateFollowers: (platform: Platform, val: number | undefined) => void;
	hashtags: string[];
	setHashtags: Dispatch<SetStateAction<string[]>>;
	companions?: number;
	setCompanions: (companion: number) => void;
	id?: number;
	setId?: (id: number) => void;
	success?: boolean;
	setSuccess?: (success: boolean) => void;
	isSaveDraft?: boolean;
	setIsSaveDraft?: (save: boolean) => void;
	increaseModalOpen?: boolean;
	setIncreaseModalOpen?: (open: boolean) => void;
	hasCompanion: boolean;
	setHasCompanion: (companion: boolean) => void;
	totalSlots: number;
	refetch: () => void;
}

export type CampaignCreateRequest = Pick<
	CampaignCreateData,
	| 'socialPostTypes'
	| 'title'
	| 'summary'
	| 'holidays'
	| 'charge'
	| 'slots'
	| 'treatmentTime'
	| 'genders'
	| 'hashtags'
	| 'companions'
> & {
	genre?: string;
	service?: string;
	startTime?: string;
	endTime?: string;
	storeId?: number;
	thumb?: File | string;
	images?: Array<File | string>;
	imgList?: string[];
	instagramCount?: number;
	tiktokCount?: number;
};

export interface CampaignCreateResponse {
	id: number;
}

export interface CampaignSlots {
	slots: number;
	totalInitialSlot: number;
}

export interface CampaignSlotsIncreaseResponse {
	message: string;
}
